import { createReducer, on } from "@ngrx/store";
import * as DeviceActions from "./device-actions";
import { DeviceStateInterface } from "src/app/devices/models/deviceStateInterface";

export const initialState: DeviceStateInterface = {
    isLoading: false,
    isLoadingImport: false,
    devices: [],
    activeDevice: null,
    error: null,
};

export const deviceReducers = createReducer(
    initialState, 

    // get devices
    on(DeviceActions.getDevices, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(DeviceActions.getDevicesSuccess, (state, action) => ({
        ...state, 
        isLoading: false, 
        devices: action.devices.slice().sort((a, b) => a.serialNumber?.localeCompare(b.serialNumber))
    })),
    on(DeviceActions.getDevicesFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // get device by Comapny
    on(DeviceActions.getDevicesByCompany, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(DeviceActions.getDevicesByCompanySuccess, (state, action) => ({
        ...state, 
        isLoading: false, 
        devices: action.devices.slice().sort((a, b) => a.serialNumber?.localeCompare(b.serialNumber))
    })),
    on(DeviceActions.getDevicesByCompanyFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // get device by id
    on(DeviceActions.getDeviceById, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(DeviceActions.getDeviceByIdSuccess, (state, action) => ({
        ...state, 
        isLoading: false, 
        activeDevice: action.device
    })),
    on(DeviceActions.getDeviceByIdFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // create device 
    on(DeviceActions.createDevice, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(DeviceActions.createDeviceSuccess, (state, action) => {
        // Add the new device to the list of devices
        const updatedDevices = [...state.devices, action.device];
    
        // Sort devices by serial number, handling null values
        const sortedDevices = updatedDevices.sort((a, b) => {
            // If serial number is null, consider it as less than any non-null value
            const serialA = a.serialNumber || '';
            const serialB = b.serialNumber || '';
    
            // Compare serial numbers, treating empty strings as the lowest possible value
            return serialA.localeCompare(serialB);
        });
    
        return {
            ...state,
            isLoading: false,
            devices: sortedDevices,
        };
    }),
    
    on(DeviceActions.createDeviceFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // update device
    on(DeviceActions.updateDevice, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(DeviceActions.updateDeviceSuccess, (state, action) => {
        const updatedIndex = state.devices.findIndex(device => device.id === action.device.id);
        
        if (updatedIndex === -1) {
            return state; // If product not found, return current state
        }

        const updated = [...state.devices];
        updated[updatedIndex] = action.device;

        return {
            ...state,
            isLoading: false,
            devices: updated.sort((a, b) => a.serialNumber.localeCompare(b.serialNumber))
        };
    }),
    on(DeviceActions.updateDeviceFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // delete device
    on(DeviceActions.deleteDevice, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(DeviceActions.deleteDeviceSuccess, (state,action) => ({
        ...state, 
        isLoading: false,
        devices: state.devices.filter(device => device.id !== action.id)
      })),
    on(DeviceActions.deleteDeviceFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // import devices
    on(DeviceActions.importDevices, (state) => ({ 
        ...state, 
        isLoadingImport: true 
    })),
    on(DeviceActions.importDevicesSuccess, (state, action) => ({
        ...state,
        isLoadingImport: false
    })),
    on(DeviceActions.importDevicesFailure, (state, action) => ({ 
        ...state, 
        isLoadingImport: false, 
        error: action.error 
    }))
);